import { Map, Placemark, YMaps } from "@pbe/react-yandex-maps";

import i18next from "i18next";
import { Content, Info, MapLocation, Subtitles, Title, Wrapper, WrapperInner } from "./style";
import { Link } from "react-router-dom";

export const ContactsComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <Title>{t("contact_information")}</Title>
      <WrapperInner>
        <Info>
          <div>
            <Subtitles>{t("address")}</Subtitles>
            <Content>{t("contact_address")}</Content>
          </div>

          <div>
            <Subtitles>{t("phone_number")}</Subtitles>
            <Content>
              <Link to="tel:+74956400451">+7(495)640-04-51</Link>
              <br />
              <small>{t("working_hours")}</small>
            </Content>
            <Content style={{ marginTop: "8px" }}>
              <Link to="tel:+79856344104">+7(985)634-41-04</Link>
            </Content>
          </div>

          <div>
            <Subtitles>{t("email")}</Subtitles>
            <Content>
              <Link to="mailto:avia@dushanbe24.ru">avia@dushanbe24.ru</Link>
            </Content>
          </div>
        </Info>

        <MapLocation>
          <Subtitles>{t("location")}</Subtitles>
          <Content style={{ marginBottom: "20px" }}>{t("location_text")}</Content>

          <YMaps
            preload={true}
            query={{
              lang: "ru_RU",
            }}
          >
            <Map
              width={"350px"}
              height={"350px"}
              defaultState={{
                center: [55.451630, 37.859462],
                zoom: 13,
                controls: ["zoomControl", "fullscreenControl"],
              }}
              modules={["control.ZoomControl", "control.FullscreenControl"]}
            >
              <Placemark
                defaultGeometry={[55.451630, 37.859462]}
                properties={{
                  balloonContentBody: "А-105, 40-й километр, 3, городской округ Домодедово, Московская область, 142034",
                }}
              />
            </Map>
          </YMaps>
        </MapLocation>
      </WrapperInner>
    </Wrapper>
  );
};
